"use client";

import * as React from "react";
import { cn } from "cn";

function Label({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<"label"> & {
  /* Local contract (DESIGN.md §6): the dense field caption that sits above a
     control in a compact settings row. `text-*`/`text-muted-foreground` are the
     component's, so a page gets the face by setting `variant`, not by restyling. */
  variant?: "default" | "caption";
}) {
  return (
    <label
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        variant === "caption" && "text-xs text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
